
export const calculatePriceWithMarkup = (baseCost, markupPercentage = 0) => {
    if (!baseCost || isNaN(baseCost)) {
        return "0.00";
    }
    
    const markupValue = markupPercentage || 0;
    const finalPrice = Number(baseCost) * (1 + markupValue / 100);
    return finalPrice.toFixed(2);
};

export const getMarkupFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    const markupParam = params.get('mkp');
    return markupParam ? parseFloat(markupParam) : 0;
};

export const getMarkupValue = (props = {}) => {
    // First try to get from props
    if (props.markup !== undefined && props.markup !== null) {
        return parseFloat(props.markup);
    }
    
    // Fallback to URL parameters
    return getMarkupFromURL();
};
